// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let accessLevelEnum = {
    'ReadOnly': 0,
    'ReadWrite': 1,
    'ReadWriteDelete': 2
};

export default accessLevelEnum;
